export default "__VITE_ASSET__CIAVV6iP__"